import { call, put, takeLatest } from "redux-saga/effects";
import {
  onGetImages,
  onGetImagesSuccess,
  onGetImagesError,
  onVenueImagesUpload,
  onVenueImagesUploadSuccess,
  onVenueImagesUploadError,
  onVenueSingleImageUpload,
  onVenueSingleImageUploadSuccess,
  onVenueSingleImageUploadError,
} from "../Store/Slices/venueImageSlice";
import {
  callVenueImagesApi,
  callImagesUploadApi,
  callGetImagesApi,
} from "../Context/businessApi";

function* getImagesSaga({ payload }) {
  const businessId = payload?.businessId ?? payload;
  if (!businessId) return;
  try {
    const response = yield call(callGetImagesApi, businessId);
    const code = response.httpStatusCode ?? response?.status;
    if (code === "200" || code === 200) {
      const data = response.data ?? response;
      const images = Array.isArray(data)
        ? data
        : (data?.images ?? data?.data ?? []);
      yield put(onGetImagesSuccess({ data: images }));
    } else {
      yield put(onGetImagesError());
    }
  } catch (error) {
    yield put(onGetImagesError());
  }
}

function* venueImagesSaga({ payload }) {
  const { businessId, formData } = payload;
  try {
    const response = yield call(callVenueImagesApi, businessId, formData);
    const code = response.httpStatusCode ?? response.status;
    if (code === "200" || code === 200) {
      
      yield put(
        onVenueImagesUploadSuccess({
          message: response.message || "Images uploaded",
          status_code: code,
        })
      );
    } else {
      yield put(
        onVenueImagesUploadError({
          message: response.message || "Upload failed",
          status_code: code,
        })
      );
    }
  } catch (error) {
    const message =
      error.response?.data?.message || error.message || "Something went wrong";
    yield put(onVenueImagesUploadError({ message, status_code: 400 }));
  }
}

function* venueSingleImageSaga({ payload }) {
  const { businessId, file, type, galleryIndex, imageId, isDeleted } = payload ?? {};

  if (!file && !imageId) {
    yield put(
      onVenueSingleImageUploadError({ message: "No image or id provided" })
    );
    return;
  }
  
  if (isDeleted === true && imageId != null) {
    try {
      const formData = new FormData();
      const response = yield call(callImagesUploadApi, formData, {
        businessId,
        imageId,
        isDeleted: true,
      });
      const code = response.httpStatusCode ?? response.status;
      const success = code === 200 || code === 201 || code === "200" || code === "201";
      if (success) {
        
        yield put(
          onVenueSingleImageUploadSuccess({
            id: null,
            type: type || "cover",
            galleryIndex: galleryIndex ?? null,
          })
        );
      } else {
        
        yield put(
          onVenueSingleImageUploadError({
            message: response.message || "Delete failed",
          })
        );
      }
    } catch (error) {
      const message =
        error.response?.data?.message || error.message || "Something went wrong";
      yield put(onVenueSingleImageUploadError({ message }));
    }
    return;
  }
  if (!file) {
    yield put(
      onVenueSingleImageUploadSuccess({
        id: null,
        type: type || "cover",
        galleryIndex: galleryIndex ?? null,
      })
    );
    return;
  }
  try {
    const formData = new FormData();
    formData.append("image", file);
    const imageType = type === "cover" ? "cover" : "gallery";
    const displayOrder = galleryIndex != null ? galleryIndex : 0;
    const response = yield call(callImagesUploadApi, formData, {
      businessId,
      imageType,
      displayOrder,
      imageId: imageId ?? undefined,
    });
    const code = response.httpStatusCode ?? response.status;
    const id = response.data?.image?.id ?? response.id ?? imageId;
    const success = code === 200 || code === 201 || code === "200" || code === "201";
    if (success) {
      
      yield put(
        onVenueSingleImageUploadSuccess({
          id,
          type: type || "cover",
          galleryIndex: galleryIndex ?? null,
        })
      );
    } else {
      
      yield put(
        onVenueSingleImageUploadError({
          message: response.message || "Upload failed",
        })
      );
    }
  } catch (error) {
    const message =
      error.response?.data?.message || error.message || "Something went wrong";
    yield put(onVenueSingleImageUploadError({ message }));
  }
}

export default function* venueImageSaga() {
  yield takeLatest(onGetImages.type, getImagesSaga);
  yield takeLatest(onVenueImagesUpload.type, venueImagesSaga);
  yield takeLatest(onVenueSingleImageUpload.type, venueSingleImageSaga);
}
